import './HowIsWasDoneModal.scss'
import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation, Trans } from 'react-i18next'

interface HowIsWasDoneModalProps {
  open: boolean
  onClose: () => void
  title?: string
  children?: React.ReactNode
}

const HowIsWasDoneModal = ({
  open,
  onClose,
  title,
  children,
}: HowIsWasDoneModalProps) => {
  const { t }: any = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="how-is-was-done-title"
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle
        // id="how-is-was-done-title"
        className="how-is-was-done-modal-title"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          className="how-is-was-done-modal-title-text"
          // variant="h6"
          component="span"
        >
          {title || t('investigation.title')}
        </Typography>
        <IconButton className="close-modal" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="how-it-was-done-content" dividers>
        <h2 style={{ margin: 0 }}>
          {t('investigation.modalTextTile')}
        </h2>
        {children || <Trans i18nKey="investigation.modalText" />}
      </DialogContent>
    </Dialog>
  )
}

export default HowIsWasDoneModal
